import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { catchError, distinctUntilChanged, tap } from 'rxjs/operators';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { SearchService, SmartWrapperOptions } from '@brafton/atlas-api-client';
import { SearchHit, SearchResult } from '@brafton/atlas-api-client/lib/models/search.model';

@Component({
  templateUrl: './search-results.tab.html',
  styleUrls: ['./search-results.tab.scss'],
})
export class SearchResults implements OnInit, OnDestroy {
  filteredText: Filter[] = [];
  filteredOrganizations: Filter[] = [];
  filterOption = '';

  recordCount = 0;

  searchTerm?: string;
  autocompleteHits: SearchHit[] = [];
  searchResults$?: Observable<SearchResult>;
  autocompleteSubscription: any = undefined;
  subscriptions = new Subscription();

  loading = new BehaviorSubject<boolean>(false);

  options: SmartWrapperOptions = new SmartWrapperOptions(5, false, true, false, 30000);

  constructor(private searchService: SearchService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  search(searchTerm: string): void {
    this.loading.next(true);
    this.searchResults$ = this.searchService
      .performSearch(
        searchTerm,
        undefined,
        undefined,
        undefined,
        undefined,
        this.filteredOrganizations.length ? this.filteredOrganizations.map((res) => res.value) : undefined,
        undefined,
        this.options,
      )
      .pipe(distinctUntilChanged())
      .pipe(
        catchError((error) => {
          console.log('🚀 ~ error:', error);
          this.recordCount = 0;
          this.loading.next(false);
          return [];
        }),
        tap((data: SearchResult) => {
          this.recordCount = data?.totalItems ?? 0;
          this.loading.next(false);
        }),
      );
  }

  refreshPublishData() {
    if (this.filteredText.length > 0 && this.filteredText[0]?.value) {
      this.search(this.filteredText?.[0]?.value ?? '');
    } else {
      this.searchResults$ = of() as Observable<SearchResult>;
    }
  }
}
